
// Manually extracted from both offshore and onshore:
//     https://github.com/TheWorldSim/world-sim-data/blob/ed6d3ae/data/power_plants/uk/data/wind_offshore_processed_REPD_publication_Q1_2026.csv
//     https://github.com/TheWorldSim/world-sim-data/blob/ed6d3ae/data/power_plants/uk/data/wind_onshore_processed_REPD_publication_Q1_2026.csv
// using Rainbow CSV with a RBQL query of:
// SELECT a1, a3, a4.slice(0,4), a5, a6, a7, a8, a9, (a2 == "Operational" ? '"o"' : '"uc"') WHERE ["Operational", "Under Construction"].includes(a2)

import { RawWindFarmData } from "./interface"

// Ref ID,Installed Capacity (MWelec),Operational,Turbine Capacity (MW),No. of Turbines,Height of Turbines (m),lon,lat,operational or under construction
export const offshore_wind_farms: RawWindFarmData[] = [
[2470,1400.0,,14.0,100,282.0,2.173,52.137,"uc"],
[2479,30.0,2017,6.0,5,,-1.443,57.507,"o"],
[2485,10.0,2007,5.0,2,,-2.888,58.253,"o"],
[2487,90.0,2007,3.6,25,,-3.185,53.488,"o"],
[2488,12.0,2013,6.0,2,,1.192,51.703,"o"],
[2489,64.8,2009,3.6,18,,1.246,51.727,"o"],
[2490,108.0,2009,3.6,30,,1.218,51.731,"o"],
[2491,97.2,2008,3.6,27,,0.447,53.188,"o"],
[2492,90.0,2005,3.0,30,,1.094,51.461,"o"],
[2493,97.2,2008,3.6,27,,0.452,53.136,"o"],
[2494,60.0,2003,2.0,30,,-3.449,53.417,"o"],
[2495,90.0,2009,3.6,25,,-3.64,53.378,"o"],
[2496,84.0,2010,3.0,28,,-3.696,54.764,"o"],
[2497,90.0,2009,3.0,30,,-3.729,54.747,"o"],
[2498,60.0,2004,2.0,30,,1.789,52.644,"o"],
[2499,300.0,2010,3.0,100,,1.633,51.43,"o"],
[2500,183.6,2011,3.6,51,,-3.516,54.039,"o"],
[2502,1320.0,2022,8.0,165,,1.54,53.96,"o"],
[2504,49.5,2015,3.3,15,,1.08,51.45,"o"],
[2505,96.8,2018,8.8,11,,-2.073,57.146,"o"],
[2506,183.6,2012,3.6,51,,-3.609,54.081,"o"],
[2509,150.0,2012,5.0,30,,-3.439,54.089,"o"],
[2510,504.0,2012,3.6,140,,1.928,51.918,"o"],
[2511,630.0,2013,3.6,175,,1.496,51.622,"o"],
[2512,317.0,2012,3.6,88,,1.148,53.135,"o"],
[2513,270.0,2013,3.6,75,,0.498,53.184,"o"],
[2514,62.0,2013,2.3,27,,-1.095,54.645,"o"],
[2515,289.8,2017,6.3,46,154.0,0.589,53.136,"o"],
[2517,1200.0,,14.0,87,260.0,2.33,55.21,"uc"],
[2519,389.0,2014,3.6,108,,-3.462,53.985,"o"],
[2520,400.0,2017,3.45,116,140.0,-0.18,50.64,"o"],
[2521,588.0,2019,7.0,84,,-2.95,58.088,"o"],
[2522,450.0,2025,8.0,54,208.0,-2.25,56.27,"o"],
[2523,41.5,2017,8.3,5,,-1.364,55.167,"o"],
[2524,714.0,2020,7.0,102,,2.173,52.137,"o"],
[2525,1218.0,2019,7.0,174,,1.421,53.682,"o"],
[2526,353.0,2018,6.3,56,,2.04,51.88,"o"],
[2528,7.0,2014,6.0,1,,-2.958,56.161,"o"],
[2532,857.0,2022,9.5,90,187.0,0.862,53.212,"o"],
[2533,659.0,2018,6.0,110,222.0,-3.74,54.09,"o"],
[2534,950.0,2022,9.5,100,204.0,-2.791,57.967,"o"],
[2538,402.0,2017,6.0,67,,0.613,53.117,"o"],
[2539,258.0,2017,8.0,32,,-3.27,53.48,"o"],
[2540,1075.0,2023,9.2,114,,-1.927,56.636,"o"],
[2541,2400.0,,113.0,190,260.0,1.668,55.967,"uc"],
[2543,576.0,2015,3.6,160,,-3.627,53.454,"o"],
[2544,219.0,2015,3.0,73,,0.501,53.387,"o"],
[2545,210.0,2015,6.0,35,,0.561,53.098,"o"],
[2546,90.0,2006,3.0,30,,-3.298,53.991,"o"],
[6136,49.5,2021,9.5,6,176.0,-1.874,56.997,"o"],
[6158,882.0,,14.7,60,230.0,-3.313,58.07,"uc"],
[6264,10.0,,5.0,2,201.0,-3.877,58.698,"uc"],
[6483,1400.0,,,92,,2.552,52.62,"uc"],
[6501,283.5,2018,6.3,45,154.0,0.589,53.136,"o"],
[6556,1400.0,,,100,252.0,2.33,55.21,"uc"],
]

export const onshore_wind_farms: RawWindFarmData[] = [
[2555,1.5,2000,1.47,1,,1.654,52.71,"o"],
[2556,1.5,1999,1.47,1,,0.683,52.657,"o"],
[2559,10.2,1998,0.54,19,,-3.971,52.466,"o"],
[2563,58.5,2005,1.5,39,,-3.751,52.405,"o"],
[2564,16.8,1996,0.6,28,,-3.608,52.549,"o"],
[2565,16.8,1996,0.6,28,,-3.579,52.542,"o"],
[2566,3.4,2002,0.56,6,,-3.672,52.658,"o"],
[2567,5.6,1996,0.4,14,,-4.346,53.375,"o"],
[2568,2.6,2002,0.85,3,,-3.588,52.996,"o"],
[2574,3.0,1999,0.5,6,,-3.039,53.465,"o"],
[2576,15.3,2002,0.85,18,,-3.674,52.64,"o"],
[2582,20.4,1997,2.25,9,,-4.466,53.354,"o"],
[2586,2.6,2001,0.9,3,,-1.823,54.764,"o"],
[2587,1.8,2000,0.6,3,,-1.989,55.087,"o"],
[2591,3.0,1997,0.75,4,,-1.427,54.827,"o"],
[2613,2.3,2000,0.4,6,,-3.072,54.871,"o"],
[2617,2.5,1997,0.5,5,,-3.147,54.205,"o"],
[2618,10.4,2007,1.3,8,,-3.275,54.723,"o"],
[2624,4.2,1996,0.6,7,,-3.543,54.674,"o"],
[2625,5.4,1996,0.6,9,,-3.556,54.66,"o"],
[2626,2.4,1998,0.6,4,,-3.325,54.204,"o"],
[2630,3.9,2002,1.3,3,,-4.441,51.997,"o"],
[2636,3.6,2001,0.7,5,,-4.53,51.757,"o"],
[2653,2.6,2003,1.3,2,,-3.725,53.136,"o"],
[2659,9.0,2002,1.3,7,,0.099,53.669,"o"],
[2672,2.4,2013,0.8,3,,-2.288,55.867,"o"],
[2673,20.0,2011,2.5,8,,-3.979,57.992,"o"],
[2674,26.0,2011,2.0,13,,-3.66,51.736,"o"],
[2680,6.9,2013,2.3,3,,-1.692,53.537,"o"],
[2683,2.0,2011,2.0,1,,0.15,51.529,"o"],
[2687,1.5,2011,0.75,2,,-3.447,56.056,"o"],
[2691,2.3,2010,2.3,1,,-2.652,57.661,"o"],
[2694,1.5,2010,1.5,1,,1.004,51.863,"o"],
[2695,2.0,2016,2.0,1,,-1.084,53.677,"o"],
[2697,4.3,2010,0.9,5,,-3.073,59.096,"o"],
[2704,1.5,2011,1.5,1,,-3.444,56.054,"o"],
[2708,2.3,2009,1.3,1,,-2.581,57.626,"o"],
[2711,13.2,2000,0.66,20,,-4.126,55.363,"o"],
[2713,4.8,1993,0.4,12,,-3.136,54.257,"o"],
[2715,4.6,2006,0.76,6,,0.238,53.321,"o"],
[2723,15.0,2011,2.5,6,,-4.884,57.155,"o"],
[2724,2.6,2010,0.85,3,,-2.814,57.315,"o"],
[2741,6.0,2012,2.0,3,,-1.911,57.572,"o"],
[2742,2.0,2010,2.0,1,,-3.123,58.827,"o"],
[2747,1.2,2004,0.3,4,,-1.914,53.962,"o"],
[2757,109.0,2013,3.0,36,,-4.318,55.639,"o"],
[2758,1.7,2010,0.85,2,,-2.241,57.472,"o"],
[2776,9.0,1993,0.45,20,,-3.465,51.569,"o"],
[2780,4.6,2015,2.0,2,,-3.318,56.091,"o"],
[2782,2.3,2009,2.3,1,,-2.261,57.392,"o"],
[2796,7.5,2012,2.5,3,,-4.349,58.003,"o"],
[2804,2.3,2011,2.3,1,,-3.104,51.507,"o"],
[2822,2.3,2012,2.3,1,,-2.646,57.66,"o"],
[2830,2.3,2011,2.3,1,,-6.02,54.688,"o"],
[2839,5.2,2012,1.3,4,,-2.291,56.933,"o"],
[2860,20.7,,2.3,9,93.0,-3.924,56.296,"uc"],
[2866,4.7,2013,2.35,2,,-6.233,54.88,"o"],
[2867,7.7,2013,2.5,3,,-2.272,56.894,"o"],
[2873,13.8,2019,2.3,6,100.0,-3.594,52.42,"o"],
[2875,2.0,2012,2.0,1,,0.121,52.571,"o"],
[2888,10.0,2017,3.0,4,,-6.869,54.899,"o"],
[2902,26.0,2010,2.0,13,,-3.773,56.209,"o"],
[2921,1.3,1992,0.3,4,,-1.914,53.962,"o"],
[2922,4.6,2009,1.3,2,,-2.581,57.626,"o"],
[2923,5.0,2010,1.67,3,,-2.043,57.622,"o"],
[2927,5.1,2008,0.85,6,,-7.334,54.807,"o"],
[2928,16.0,2009,2.0,8,,-0.667,53.628,"o"],
[2932,3.0,2008,3.0,1,,-1.007,53.682,"o"],
[2935,4.0,2006,2.0,2,,-3.54,54.671,"o"],
[2938,15.0,2010,3.0,5,,-1.152,53.118,"o"],
[2940,20.0,2010,2.5,8,,-4.05,56.054,"o"],
[2942,1.3,2007,1.3,1,,-0.236,53.744,"o"],
[2943,1.3,2008,1.0,2,,-0.938,53.757,"o"],
[2944,4.0,2005,0.66,6,,-1.481,54.914,"o"],
[2950,8.4,2009,1.3,6,,-4.534,51.759,"o"],
[2952,6.0,2007,2.0,3,,0.031,52.513,"o"],
[2953,4.0,2007,2.0,2,,0.037,52.511,"o"],
[2955,24.0,2009,2.0,12,,-1.815,54.764,"o"],
[2956,5.5,1994,0.5,11,,-4.591,51.911,"o"],
[2965,1.6,2008,0.8,2,,-2.009,57.588,"o"],
[2968,14.0,2010,2.0,7,,-0.687,52.133,"o"],
[2983,8.0,2009,2.0,4,,-1.761,54.75,"o"],
[2986,6.0,2009,0.85,7,,-3.497,54.642,"o"],
[2988,4.1,2011,2.05,2,,1.703,52.415,"o"],
[2991,4.6,2009,2.3,2,,-4.248,57.788,"o"],
[2999,2.4,2009,0.8,3,,-2.325,57.427,"o"],
[3002,9.2,2011,2.5,4,,-3.348,54.853,"o"],
[3015,9.9,1994,0.45,22,,-3.566,52.367,"o"],
[3019,9.2,2011,2.3,4,,-4.705,50.638,"o"],
[3021,9.0,2008,3.0,3,,-0.172,52.558,"o"],
[3028,2.6,2009,1.3,2,,-1.378,53.388,"o"],
[3034,5.0,2009,2.5,2,,-2.963,51.567,"o"],
[3050,4.0,2011,2.0,2,,-1.431,54.788,"o"],
[3057,31.0,1993,0.3,103,,-3.431,52.442,"o"],
[3061,12.0,2010,2.0,6,,-5.2,50.05,"o"],
[3068,4.0,2011,2.0,2,,-1.622,55.103,"o"],
[3075,3.2,2009,0.9,4,,-2.19,57.421,"o"],
[3077,10.0,2008,2.0,5,,-5.187,50.18,"o"],
[3078,2.0,2010,2.0,1,,-2.786,53.888,"o"],
[3079,9.6,1993,0.4,24,,-2.15,53.75,"o"],
[3090,1.8,2001,0.9,2,,-4.279,55.692,"o"],
[3092,2.6,2006,1.3,2,,-1.338,54.84,"o"],
[3093,4.7,2001,2.3,2,,-4.284,55.691,"o"],
[3096,59.8,2009,2.3,26,,0.823,50.964,"o"],
[3097,5.0,1995,0.5,10,,-7.44,54.704,"o"],
[3101,2.0,2005,2.0,1,,0.089,52.573,"o"],
[3103,5.0,1994,0.5,10,,-6.287,55.044,"o"],
[3105,2.3,2004,2.3,1,,1.761,52.48,"o"],
[3106,5.0,1995,0.5,10,,-6.119,54.739,"o"],
[3108,48.3,2004,2.0,24,,-3.085,58.443,"o"],
[3109,120.0,2006,2.3,52,,-4.732,55.257,"o"],
[3110,2.7,2004,1.35,2,,-1.415,54.762,"o"],
[3112,5.0,1994,0.5,10,,-6.82,55.022,"o"],
[3113,9.0,2007,1.5,6,,-7.605,54.641,"o"],
[3114,62.5,2004,2.5,25,,-2.508,55.883,"o"],
[3116,124.0,2004,2.3,54,,-3.763,55.762,"o"],
[3117,24.0,2003,2.0,12,,-4.806,55.644,"o"],
[3118,5.0,1997,0.5,10,,-7.339,54.81,"o"],
[3119,72.0,2006,2.0,36,,-4.059,56.27,"o"],
[3120,1.5,2000,1.5,1,,-3.144,59.113,"o"],
[3122,5.0,1995,0.5,10,,-7.628,54.19,"o"],
[3126,13.0,2005,0.85,15,,-3.443,58.3,"o"],
[3128,26.7,2008,2.0,13,,-0.218,52.938,"o"],
[3129,18.0,2007,2.0,9,,0.123,52.57,"o"],
[3130,19.5,2005,1.5,13,,-7.696,54.547,"o"],
[3132,16.0,2005,2.0,8,,-0.109,52.519,"o"],
[3133,12.0,2008,2.0,6,,0.107,52.836,"o"],
[3135,23.0,2007,2.3,10,,-6.458,57.43,"o"],
[3147,16.0,2008,2.0,8,,-1.65,53.999,"o"],
[3149,28.0,2012,2.0,14,,-4.806,55.756,"o"],
[3155,1.8,2008,1.8,1,,-0.106,52.447,"o"],
[3157,9.6,2004,0.6,8,,0.238,53.321,"o"],
[3158,5.9,2004,2.96,2,,0.151,51.519,"o"],
[3159,1.8,2003,1.79,1,,0.701,52.658,"o"],
[3161,2.0,2008,2.0,1,,-2.583,51.254,"o"],
[3168,9.0,2008,1.3,6,,-7.427,54.705,"o"],
[3171,16.0,2006,2.0,8,,-2.654,54.07,"o"],
[3172,11.7,2008,1.3,8,,-3.725,53.136,"o"],
[3177,65.0,2008,2.5,26,,-2.268,53.669,"o"],
[3179,1.2,2003,1.2,1,,-2.318,52.129,"o"],
[3186,2.6,2008,1.3,2,,0.241,53.143,"o"],
[3190,17.5,2010,2.5,7,,-2.211,56.964,"o"],
[3191,15.0,2009,3.0,5,,-6.565,55.002,"o"],
[3194,6.0,2007,2.0,3,,-2.706,51.514,"o"],
[3200,12.3,2007,1.75,7,,-2.692,57.451,"o"],
[3201,37.5,2007,2.5,14,,-4.096,56.071,"o"],
[3202,47.5,2008,2.5,19,,-4.059,58.04,"o"],
[3205,38.0,2010,2.0,19,,-4.5,58.002,"o"],
[3207,3.9,2008,1.3,3,,-3.25,58.449,"o"],
[3210,2.0,2005,2.0,1,,-0.986,51.419,"o"],
[3214,6.0,2010,2.0,3,,-3.018,55.765,"o"],
[3218,20.5,2011,2.05,10,,-1.397,54.664,"o"],
[3220,26.0,2008,1.3,20,,-3.92,55.567,"o"],
[3223,5.2,2008,1.3,4,,-1.435,54.722,"o"],
[3229,9.4,2004,0.85,11,,-4.029,52.307,"o"],
[3232,14.0,2010,2.0,7,,-3.611,55.816,"o"],
[3233,1.7,2007,0.85,2,,-5.132,50.177,"o"],
[3236,4.0,2007,2.0,2,,-3.903,55.912,"o"],
[3241,25.0,2009,2.5,10,,-6.286,55.019,"o"],
[3242,8.8,2007,1.75,5,,-6.081,54.804,"o"],
[3243,15.0,2011,2.5,6,,-7.317,54.929,"o"],
[3244,11.7,2007,1.3,9,,-7.0,54.97,"o"],
[3245,30.0,2009,2.5,12,,-7.106,54.509,"o"],
[3247,4.5,2011,1.3,3,,-1.236,53.314,"o"],
[3248,8.0,2008,2.0,4,,-1.676,54.824,"o"],
[3251,20.0,2007,2.5,8,,-7.089,54.686,"o"],
[3253,20.0,2010,2.5,8,,-7.342,54.439,"o"],
[3258,120.0,2011,2.0,60,,-4.797,55.069,"o"],
[3260,56.0,2011,2.3,24,,-4.746,55.128,"o"],
[3263,19.5,2011,2.5,8,,-7.333,54.462,"o"],
[3264,6.5,2008,1.3,5,,-1.666,51.616,"o"],
[3272,1.0,2006,1.0,1,,-5.061,51.726,"o"],
[3277,15.6,2009,1.3,12,,-3.579,52.542,"o"],
[3285,6.2,2009,2.05,3,,-3.202,58.439,"o"],
[3290,5.2,2008,1.3,4,,-1.758,54.764,"o"],
[3292,29.7,2001,0.66,45,,-5.587,55.573,"o"],
[3294,15.0,2001,0.57,26,,-5.568,55.58,"o"],
[3295,7.8,1999,0.55,14,,-5.298,56.382,"o"],
[3296,9.0,1997,0.5,18,,-4.427,57.705,"o"],
[3297,17.0,1997,,34,,-4.427,57.71,"o"],
[3298,19.3,2010,0.9,23,,-5.219,56.219,"o"],
[3299,31.2,2002,1.3,24,80.0,-3.068,55.705,"o"],
[3301,7.8,1995,0.6,13,,-3.92,55.555,"o"],
[3306,3.9,2006,1.3,3,,-6.438,58.177,"o"],
[3307,5.0,2006,2.5,2,,-3.149,59.118,"o"],
[3308,2.3,2000,1.15,2,,-3.14,59.109,"o"],
[3309,4.9,2003,1.3,4,,-3.688,58.602,"o"],
[3310,3.7,2000,0.75,5,,-1.236,60.165,"o"],
[3311,26.0,2005,1.3,20,,-2.636,57.425,"o"],
[3313,3.2,2009,0.8,4,,-5.013,51.72,"o"],
[3317,57.0,,4.0,14,136.0,-3.488,55.478,"uc"],
[3321,1.0,2014,0.5,2,,-2.869,58.913,"o"],
[3328,126.0,,6.0,21,200.0,-3.887,55.599,"uc"],
[3354,3.6,2015,1.8,2,,1.092,52.695,"o"],
[3359,1.6,2017,0.8,2,,-3.007,54.869,"o"],
[3361,1.0,2014,0.5,2,,-2.738,53.511,"o"],
[3368,1.5,2016,0.5,3,,-4.335,50.744,"o"],
[3370,1.5,2014,0.5,3,,-2.747,56.259,"o"],
[3371,49.9,,3.0,12,130.0,-4.242,57.257,"uc"],
[3378,1.6,2014,0.8,2,,-4.684,51.772,"o"],
[3380,5.0,2013,2.5,2,,-4.195,58.536,"o"],
[3382,2.3,2016,2.5,1,,-1.628,53.091,"o"],
[3387,49.9,,2.0,19,,-5.611,55.546,"uc"],
[3390,6.5,2001,1.3,5,,-2.635,54.336,"o"],
[3391,4.6,1999,0.66,7,,-3.181,54.184,"o"],
[3392,9.8,2001,0.6,16,,-4.956,50.47,"o"],
[3396,9.2,2018,2.3,4,,-3.279,56.637,"o"],
[3398,4.6,2014,2.3,2,,-2.401,56.923,"o"],
[3403,2.3,2011,2.3,1,,-2.341,57.411,"o"],
[3404,4.6,2011,2.3,2,,-2.308,57.429,"o"],
[3405,2.3,2010,2.3,1,,-2.424,57.594,"o"],
[3408,2.3,2009,2.5,1,,-3.149,59.118,"o"],
[3415,12.0,2015,3.0,4,,-3.862,56.032,"o"],
[3429,1.0,2018,0.5,2,,-2.251,55.904,"o"],
[3432,5.9,1993,0.45,13,,-1.67,53.532,"o"],
[3433,2.3,2015,2.3,1,,-3.137,58.572,"o"],
[3435,47.0,2021,4.3,11,150.0,-3.959,58.088,"o"],
[3437,1.0,2016,0.5,2,77.0,0.278,51.522,"o"],
[3440,138.0,2010,2.3,60,,-2.529,55.899,"o"],
[3448,15.0,2008,1.67,9,,-4.943,56.288,"o"],
[3449,16.0,2008,0.8,20,,0.069,53.423,"o"],
[3450,2.6,2011,0.85,3,,-4.119,50.972,"o"],
[3453,6.0,2009,2.0,3,,-3.982,55.696,"o"],
[3457,27.6,2010,2.3,12,,-2.877,55.769,"o"],
[3458,2.4,2011,0.8,3,,-4.488,50.912,"o"],
[3466,2.4,2001,0.8,3,,-1.758,54.764,"o"],
[3467,12.8,2002,0.85,15,,-5.667,55.495,"o"],
[3479,14.0,2005,1.75,8,,0.115,52.603,"o"],
[3480,14.0,2012,2.0,7,,0.141,52.593,"o"],
[3487,27.0,2008,1.5,18,,-3.666,56.249,"o"],
[3489,322.0,2007,2.3,140,,-4.279,55.681,"o"],
[3491,4.0,1999,0.66,6,,-3.077,54.871,"o"],
[3492,8.8,2004,0.8,11,,-3.504,54.629,"o"],
[3494,2.8,2004,1.37,2,,-1.678,54.847,"o"],
[3495,5.5,2003,1.83,3,,-1.3,54.694,"o"],
[3496,1.3,2004,1.3,1,,-1.415,54.762,"o"],
[3502,70.0,,4.6,15,14.99,-4.235,55.356,"uc"],
[3503,67.1,2025,4.5,15,149.9,-4.312,55.267,"o"],
[3504,8.2,2010,2.0,4,,-1.427,54.827,"o"],
[3507,10.0,2010,2.0,5,,-1.41,54.766,"o"],
[3510,2.0,2009,2.0,1,,-1.076,53.3,"o"],
[3511,6.6,2002,0.3,22,,-4.547,50.646,"o"],
[3524,2.4,2010,0.8,3,,-2.06,57.406,"o"],
[3529,2.7,2002,0.9,3,,-2.66,59.097,"o"],
[3532,2.5,2005,2.5,1,,-2.393,57.376,"o"],
[3533,10.0,2009,2.5,4,,-3.005,53.45,"o"],
[3534,50.6,2004,2.3,22,,-3.363,57.537,"o"],
[3536,20.7,2010,2.3,9,,-2.545,55.913,"o"],
[3538,22.0,2012,2.0,11,,-3.42,55.539,"o"],
[3539,30.0,2009,2.5,12,,-0.289,54.007,"o"],
[3548,12.0,2011,2.0,6,,-2.243,57.428,"o"],
[3552,2.4,1997,0.3,8,,-3.877,52.408,"o"],
[3554,15.8,2001,1.75,9,,-5.544,55.629,"o"],
[3556,16.4,2005,0.42,39,,-3.707,52.415,"o"],
[3566,7.3,2002,0.66,11,,-7.149,54.394,"o"],
[3568,5.9,2000,0.66,9,,-7.183,54.393,"o"],
[3570,17.2,2000,0.66,26,,-2.846,55.806,"o"],
[3574,28.6,2007,1.3,22,,-2.432,55.799,"o"],
[3575,26.0,2003,1.3,20,,-7.034,54.963,"o"],
[3578,4.5,1998,0.3,15,,-5.137,50.289,"o"],
[3579,29.8,2009,0.85,35,,-2.842,55.787,"o"],
[3581,9.6,2011,0.8,12,,-3.433,56.305,"o"],
[3585,33.3,2004,0.95,35,,-5.156,56.039,"o"],
[3592,9.2,2010,2.3,4,,-3.406,53.025,"o"],
[3593,7.8,1995,0.6,13,,-3.92,55.555,"o"],
[3594,4.6,2011,2.3,2,,-2.724,57.611,"o"],
[3598,10.0,2008,2.5,4,125.0,-4.891,57.15,"o"],
[3602,24.0,2010,2.0,12,,-0.948,53.73,"o"],
[3605,38.0,2009,2.0,19,,-2.827,55.669,"o"],
[3606,14.0,2008,2.0,7,,-1.397,54.664,"o"],
[3607,16.0,2005,2.0,8,,0.095,52.597,"o"],
[3608,24.0,2006,2.0,12,,-0.029,52.431,"o"],
[3609,16.4,2006,2.0,8,,-0.226,52.733,"o"],
[3611,4.7,2000,0.67,7,,-3.571,54.597,"o"],
[3613,6.5,2011,1.3,5,,-3.52,54.579,"o"],
[3614,1.2,2004,0.22,5,,-3.325,54.204,"o"],
[3619,23.8,2017,3.4,7,136.0,-4.965,57.096,"o"],
[3627,36.8,2017,2.3,16,,-3.334,55.107,"o"],
[3633,1.6,,0.8,2,,-3.884,55.558,"uc"],
[3645,5.0,2017,2.5,2,119.0,-0.539,53.714,"o"],
[3647,66.0,2016,3.3,20,,-4.049,57.389,"o"],
[3651,2.4,2015,0.8,3,,-3.828,56.055,"o"],
[3657,28.7,2016,2.05,14,,-0.905,53.608,"o"],
[3659,2.7,1992,0.3,9,,-1.495,55.125,"o"],
[3660,6.4,2011,0.8,8,,-3.451,51.651,"o"],
[3662,70.0,2012,2.0,35,,-3.959,58.059,"o"],
[3664,8.2,2014,2.05,4,,-2.673,51.512,"o"],
[3666,12.5,2013,2.5,5,,-2.483,57.462,"o"],
[3667,2.2,2013,2.2,1,,-3.961,55.725,"o"],
[3668,4.6,2011,2.3,2,,-6.458,57.43,"o"],
[3670,6.9,2013,2.3,3,,-7.348,57.234,"o"],
[3671,14.0,2013,2.0,7,,0.166,52.751,"o"],
[3672,5.0,2013,2.5,2,,1.127,52.337,"o"],
[3673,4.0,2017,2.0,2,,-2.117,52.702,"o"],
[3674,6.0,2013,2.0,3,,-1.928,54.848,"o"],
[3676,15.0,2013,2.5,6,,-3.922,55.599,"o"],
[3677,19.8,2013,3.3,6,,-1.297,53.383,"o"],
[3678,1.0,2015,1.0,1,,-6.648,54.769,"o"],
[3680,4.6,2013,2.3,2,,-6.199,54.873,"o"],
[3681,2.4,2011,0.8,3,,-2.027,57.494,"o"],
[3682,8.0,2011,2.0,4,,-1.179,52.502,"o"],
[3684,10.0,2013,2.5,4,,-3.295,56.145,"o"],
[3685,22.0,2012,2.0,11,,-1.166,52.412,"o"],
[3686,6.0,2013,2.0,3,,-0.034,52.537,"o"],
[3688,28.0,2013,2.0,14,,-4.212,55.637,"o"],
[3690,18.0,2012,3.0,6,,-4.775,55.731,"o"],
[3691,4.6,2014,2.3,2,,-2.856,57.603,"o"],
[3693,1.8,2013,0.9,2,,-2.982,59.277,"o"],
[3694,50.4,2016,2.65,19,,-2.769,53.301,"o"],
[3695,57.4,2018,2.05,28,,-4.123,51.961,"o"],
[3698,4.6,2012,2.3,2,,-2.201,57.595,"o"],
[3699,2.5,2014,2.5,1,,-1.118,52.698,"o"],
[3700,12.5,2016,2.5,5,,-0.8,53.795,"o"],
[3701,6.9,2013,2.3,3,,-3.177,56.955,"o"],
[3702,12.0,2013,2.0,6,,-4.343,55.775,"o"],
[3703,4.0,2013,2.0,2,,-2.866,53.9,"o"],
[3705,22.5,2015,2.5,9,,-3.51,51.715,"o"],
[3707,24.6,2017,2.05,12,,-3.479,52.611,"o"],
[3711,34.0,2017,2.0,17,137.0,-3.284,52.413,"o"],
[3713,2.0,2017,2.0,1,,-6.955,54.614,"o"],
[3716,1.7,2012,0.85,2,,-6.307,54.766,"o"],
[3717,2.5,2012,2.5,1,,-7.009,54.552,"o"],
[3718,2.4,2013,0.8,3,,-2.448,57.283,"o"],
[3722,4.5,2012,1.5,3,,-2.29,57.607,"o"],
[3723,1.0,2014,0.5,2,,-1.942,57.431,"o"],
[3726,4.0,2013,2.0,2,,-3.171,51.687,"o"],
[3732,1.5,2014,1.5,1,,-1.279,52.174,"o"],
[3733,4.6,2013,2.3,2,,0.851,51.395,"o"],
[3734,2.0,2017,2.0,1,,-2.481,51.723,"o"],
[3735,10.0,2012,2.0,5,,-0.61,53.845,"o"],
[3738,8.2,2016,2.05,4,125.0,0.748,51.443,"o"],
[3739,10.3,2013,2.0,5,,-1.015,53.151,"o"],
[3741,2.0,2010,2.0,1,,0.123,52.57,"o"],
[3745,4.5,2017,0.9,5,,-1.005,60.666,"o"],
[3746,10.0,2013,2.0,5,,-4.751,57.279,"o"],
[3747,2.5,2013,2.5,1,,-3.933,55.854,"o"],
[3748,24.0,2012,2.0,12,,-2.389,53.714,"o"],
[3749,7.5,2013,2.5,3,,-0.027,53.752,"o"],
[3752,26.0,2012,2.0,13,,-1.54,55.202,"o"],
[3754,15.0,2013,2.5,6,,-1.796,55.275,"o"],
[3757,10.0,2013,2.0,5,,-3.226,58.439,"o"],
[3758,10.8,2012,0.9,12,,-5.477,55.933,"o"],
[3761,7.5,2013,2.5,3,,-2.306,53.771,"o"],
[3764,7.2,2016,0.8,9,77.0,-1.034,52.806,"o"],
[3765,12.0,2013,2.0,6,,-0.109,52.519,"o"],
[3772,20.5,2016,2.1,10,,-5.485,55.681,"o"],
[3776,1.7,2017,0.85,2,,-2.875,57.323,"o"],
[3784,6.9,2013,2.3,3,,-2.542,57.5,"o"],
[3787,85.0,2017,3.4,25,,-4.965,57.096,"o"],
[3791,4.0,2012,2.0,2,,-1.262,54.496,"o"],
[3792,1.5,2015,1.5,1,110.0,-2.872,54.038,"o"],
[3793,2.5,2014,2.5,1,,-1.298,52.999,"o"],
[3795,10.0,2014,2.5,4,,-0.537,52.308,"o"],
[3799,9.0,2013,3.0,3,,-3.746,55.872,"o"],
[3802,9.2,2013,2.3,4,,-1.899,57.582,"o"],
[3803,2.0,2013,2.0,1,,-2.78,54.007,"o"],
[3804,1.6,2013,0.8,2,,-2.843,57.599,"o"],
[3806,2.4,2014,0.8,3,80.0,-2.647,57.581,"o"],
[3807,1.7,2015,0.85,2,,-0.235,53.752,"o"],
[3809,4.6,2016,2.3,2,,-2.419,57.62,"o"],
[3810,9.0,2013,3.0,3,,-4.09,55.742,"o"],
[3814,10.0,2014,2.0,5,,-1.167,52.394,"o"],
[3818,7.5,2014,2.5,3,,-2.41,56.844,"o"],
[3819,1.5,2015,0.5,3,,-2.418,57.661,"o"],
[3827,4.6,2014,2.3,2,,0.009,53.509,"o"],
[3828,4.0,2014,2.0,2,,0.734,52.626,"o"],
[3832,2.3,2015,2.3,1,,-3.523,54.674,"o"],
[3835,17.1,2013,1.9,9,,-0.07,53.752,"o"],
[3836,4.6,2014,2.3,2,,-2.417,57.587,"o"],
[3837,10.0,2012,2.0,5,,-2.693,59.189,"o"],
[3840,3.2,2015,0.8,4,,-2.335,57.418,"o"],
[3841,7.5,2013,2.5,3,,-4.634,55.598,"o"],
[3842,1.5,2013,1.5,1,,0.386,52.771,"o"],
[3846,29.9,2020,2.3,13,,-4.373,57.77,"o"],
[3850,17.9,2017,2.35,6,,-6.258,55.085,"o"],
[3852,2.5,2017,2.5,1,,-6.28,55.044,"o"],
[3855,4.3,2014,2.3,2,110.0,-4.252,55.71,"o"],
[3856,4.6,2013,2.3,2,,-4.4,53.394,"o"],
[3857,9.2,2013,2.3,4,,-4.467,55.754,"o"],
[3859,4.0,2013,2.0,2,,-1.749,54.85,"o"],
[3862,2.5,2014,2.5,1,,0.142,51.502,"o"],
[3873,6.8,2014,3.4,2,,-3.606,55.758,"o"],
[3877,4.6,2015,2.3,2,,-7.313,54.968,"o"],
[3886,22.5,2017,2.0,11,,-5.471,55.777,"o"],
[3887,2.5,2017,2.5,1,,-2.959,51.551,"o"],
[3890,1.5,2014,1.5,1,,-0.535,52.065,"o"],
[3893,3.0,2018,3.0,1,,-0.33,53.759,"o"],
[3896,4.7,2017,2.35,2,,-3.847,51.778,"o"],
[3897,1.5,2015,2.5,1,,-1.044,52.976,"o"],
[3902,1.8,2013,0.9,2,,-2.716,58.922,"o"],
[3904,5.0,2016,2.0,2,,-3.669,51.502,"o"],
[3905,18.45,2016,2.05,9,,-1.625,55.265,"o"],
[3911,9.6,2016,3.2,3,,-2.61,57.344,"o"],
[3915,2.4,2016,1.3,3,,-3.922,55.649,"o"],
[3917,4.0,2015,2.0,2,,-4.885,50.307,"o"],
[3918,1.0,2016,0.5,2,,-4.961,50.35,"o"],
[3924,1.0,2015,0.5,2,,1.664,52.707,"o"],
[3925,7.2,2014,2.5,3,110.0,-4.254,55.72,"o"],
[3927,5.0,2013,2.5,2,,-2.674,51.538,"o"],
[3928,44.0,2012,2.0,22,,-0.936,53.622,"o"],
[3931,9.4,2012,0.85,11,,-3.46,51.556,"o"],
[3932,17.5,2013,2.5,7,,-3.496,51.606,"o"],
[3933,15.0,2016,2.5,6,,-7.02,54.544,"o"],
[3934,13.8,2013,2.3,6,,-5.912,54.731,"o"],
[3935,26.0,2012,2.0,13,,0.316,52.166,"o"],
[3936,20.0,2013,2.0,10,,0.821,51.71,"o"],
[3937,6.0,2011,2.0,3,,-1.731,53.532,"o"],
[3938,12.0,2012,2.0,6,,-1.914,54.886,"o"],
[3941,3.2,2011,0.8,4,,-4.61,50.685,"o"],
[3942,33.0,2013,3.3,10,,-0.811,53.738,"o"],
[3943,10.3,2013,2.05,5,,1.111,51.809,"o"],
[3944,2.3,2012,0.75,3,,-2.78,53.633,"o"],
[3946,12.5,2014,2.5,5,,-0.537,52.301,"o"],
[3947,2.3,2013,2.3,1,,-1.557,55.215,"o"],
[3948,24.6,2013,2.05,12,,-0.361,53.874,"o"],
[3951,41.4,2013,2.3,18,,-3.363,57.537,"o"],
[3953,18.4,2013,2.3,8,,-7.03,54.976,"o"],
[3955,27.6,2013,2.3,12,,-7.035,54.97,"o"],
[3956,10.0,2013,2.5,4,,-3.495,51.611,"o"],
[3957,8.0,2014,2.0,4,,-1.255,53.577,"o"],
[3958,7.5,2013,2.5,3,,-1.706,53.543,"o"],
[3961,2.3,2017,2.3,1,109.0,-6.412,55.01,"o"],
[3962,6.9,2017,2.3,3,109.0,-6.412,55.01,"o"],
[3963,8.0,2012,2.0,4,,-1.24,53.533,"o"],
[3964,2.0,2008,0.6,3,,-1.481,54.914,"o"],
[3968,6.9,2010,2.3,3,,-2.11,57.311,"o"],
[3969,21.0,2013,3.0,7,,-6.889,55.069,"o"],
[3971,20.0,2013,2.5,8,,-0.195,52.262,"o"],
[3972,6.2,2013,2.05,3,,-3.514,54.687,"o"],
[3976,20.0,2013,2.0,10,,-5.031,50.351,"o"],
[3978,16.0,2013,2.0,8,,-1.151,52.375,"o"],
[3980,2.4,2012,0.8,3,,-2.067,57.615,"o"],
[3981,108.0,2012,3.0,36,,-4.287,55.677,"o"],
[3982,12.0,2013,3.0,4,,0.337,51.457,"o"],
[3984,6.0,2012,2.0,3,,-1.259,54.494,"o"],
[3985,7.5,2013,2.5,3,,-1.402,54.84,"o"],
[3986,12.0,2013,2.0,6,,-2.639,54.276,"o"],
[3987,18.0,2013,2.0,9,,-0.173,53.846,"o"],
[3988,2.7,2015,0.9,3,,-6.493,58.384,"o"],
[3992,10.2,2014,3.4,3,,-0.113,53.749,"o"],
[4006,50.0,2013,2.0,25,,-3.272,58.409,"o"],
[4008,2.7,2002,0.9,3,,-2.66,59.097,"o"],
[4009,36.8,2008,2.3,16,,-3.232,56.622,"o"],
[4011,350.0,2012,2.3,152,,-3.543,55.442,"o"],
[4013,36.8,2012,2.3,16,,-4.427,57.71,"o"],
[4014,48.0,2012,2.3,21,,-3.341,57.623,"o"],
[4015,13.8,2016,2.3,6,,-3.334,55.107,"o"],
[4019,54.0,2013,3.0,18,,-1.768,55.499,"o"],
[4021,52.5,2013,2.5,21,,-3.677,58.568,"o"],
[4022,3.9,2007,1.3,3,,-3.958,52.595,"o"],
[4023,28.6,2012,1.3,22,,-2.262,55.898,"o"],
[4024,6.0,2011,0.85,7,,-5.53,55.479,"o"],
[4026,54.4,2017,3.5,16,,-2.071,55.182,"o"],
[4027,32.2,2013,2.3,14,,-3.876,56.628,"o"],
[4028,156.0,2012,3.0,52,,-3.734,56.581,"o"],
[4029,3.9,2007,1.3,3,,-3.191,54.79,"o"],
[4031,7.65,2013,0.85,9,,-2.272,56.889,"o"],
[4032,52.9,2018,2.3,23,,-4.032,55.12,"o"],
[4033,66.0,2012,3.0,22,,-4.103,51.157,"o"],
[4034,25.0,2012,2.8,9,,-3.252,56.119,"o"],
[4039,25.0,2013,2.5,10,115.0,-3.505,51.613,"o"],
[4041,32.2,2012,2.0,14,,-7.753,54.64,"o"],
[4042,20.7,2013,2.3,9,,-7.2,54.895,"o"],
[4044,36.0,2012,2.0,18,,-2.127,55.132,"o"],
[4047,18.4,2012,2.0,8,,-7.713,54.654,"o"],
[4048,15.0,2010,2.5,6,,-7.017,54.55,"o"],
[4051,24.7,2013,1.3,19,,-4.547,57.996,"o"],
[4053,9.2,2014,2.3,4,,-7.56,54.606,"o"],
[4054,18.8,2017,2.5,8,,-7.106,54.509,"o"],
[4055,14.3,2013,1.3,11,,-4.134,55.578,"o"],
[4056,2.0,2007,1.0,2,,-2.393,57.376,"o"],
[4057,18.0,2016,2.0,9,103.0,-3.689,50.972,"o"],
[4058,27.6,2011,2.3,12,,-7.289,54.92,"o"],
[4059,144.0,2013,3.0,48,,-2.688,55.831,"o"],
[4060,3.0,2013,3.0,1,,-4.215,55.797,"o"],
[4061,34.5,2013,2.3,15,,-3.929,51.773,"o"],
[4062,6.4,2013,0.8,8,,-3.048,56.571,"o"],
[4063,13.8,2013,2.3,6,,-6.511,58.257,"o"],
[4065,6.9,2018,2.3,3,,-7.569,54.635,"o"],
[4066,15.0,2014,3.0,5,,-7.637,54.198,"o"],
[4067,17.5,2016,2.0,7,,0.868,51.652,"o"],
[4068,5.0,2014,3.4,2,,-1.413,52.908,"o"],
[4069,12.3,2015,2.05,6,,-0.7,53.638,"o"],
[4070,34.9,2016,2.05,17,,-0.887,53.677,"o"],
[4072,18.0,2016,3.0,6,,-2.963,57.506,"o"],
[4073,20.0,2020,2.5,8,,-4.806,55.25,"o"],
[4075,3.0,2015,3.0,1,,-1.167,60.192,"o"],
[4076,6.2,2019,3.0,3,,-0.288,52.277,"o"],
[4078,6.9,2016,2.3,3,,-3.253,56.118,"o"],
[4081,9.2,2014,2.3,4,,-7.56,54.606,"o"],
[4084,12.5,2016,2.5,5,,-0.96,52.403,"o"],
[4085,5.7,2015,3.0,2,,-3.745,55.877,"o"],
[4088,2.0,2015,2.0,1,,-3.32,56.086,"o"],
[4093,1.5,2014,1.5,1,,-3.159,56.167,"o"],
[4094,6.4,2016,3.2,2,,-3.164,56.154,"o"],
[4097,11.5,2016,2.3,5,,1.531,52.366,"o"],
[4104,12.0,2013,2.0,6,,-3.36,54.707,"o"],
[4107,38.4,2018,3.2,12,,-7.441,54.568,"o"],
[4108,13.8,2016,2.3,6,,-6.3,54.633,"o"],
[4109,10.0,2013,0.85,12,,-2.278,57.019,"o"],
[4110,36.0,2016,2.5,14,,-3.846,55.509,"o"],
[4111,6.9,2016,2.3,3,,-6.943,54.551,"o"],
[4112,25.0,2018,2.5,10,,-7.587,54.631,"o"],
[4113,1.0,2011,0.25,4,,-1.343,52.826,"o"],
[4114,18.4,2013,2.3,8,,-2.703,57.225,"o"],
[4116,8.6,2017,2.0,3,,-0.609,52.236,"o"],
[4118,94.0,2016,3.0,33,,-4.256,57.251,"o"],
[4119,136.0,2014,2.0,68,,-3.574,55.239,"o"],
[4120,54.4,2017,3.2,17,125.0,-4.773,57.669,"o"],
[4121,29.9,2015,2.5,12,,-3.132,58.579,"o"],
[4122,22.5,2015,2.5,9,,-3.204,58.357,"o"],
[4123,51.0,2014,3.0,17,,-4.817,57.655,"o"],
[4124,34.5,2017,2.3,15,,-7.591,54.705,"o"],
[4125,26.0,2016,2.0,13,,-3.775,55.912,"o"],
[4128,45.0,,3.0,15,,-4.395,55.643,"uc"],
[4133,1.6,2016,0.8,2,,-2.622,57.157,"o"],
[4138,24.0,2013,3.0,8,,-3.518,51.698,"o"],
[4139,7.1,2017,2.35,3,110.0,-7.095,54.522,"o"],
[4140,4.6,2014,2.3,2,,-4.814,50.425,"o"],
[4141,6.2,2014,2.05,3,,-3.346,54.78,"o"],
[4142,42.0,2014,3.0,14,,-6.889,55.08,"o"],
[4143,12.0,2016,3.0,4,,-6.396,55.118,"o"],
[4151,30.0,2018,3.0,10,130.0,-7.514,54.578,"o"],
[4152,11.0,2018,2.2,5,,-7.399,54.303,"o"],
[4155,12.0,2015,2.5,4,,-7.134,54.979,"o"],
[4156,15.0,2017,2.5,6,,-6.772,54.739,"o"],
[4157,29.8,2016,0.85,35,,-4.126,55.363,"o"],
[4159,9.0,2014,3.0,3,,-2.699,51.503,"o"],
[4163,13.8,2015,2.3,6,,-2.025,55.637,"o"],
[4164,12.3,2016,2.3,6,,-1.062,52.366,"o"],
[4167,8.2,2016,2.05,4,,-1.618,55.25,"o"],
[4168,4.0,2015,2.0,2,,-4.447,50.917,"o"],
[4170,6.9,2015,2.3,3,,-2.165,57.453,"o"],
[4174,7.5,2015,2.5,3,,-2.865,54.034,"o"],
[4175,10.0,2014,2.3,4,,-0.308,52.34,"o"],
[4177,11.5,2016,2.3,5,,-3.148,54.209,"o"],
[4178,172.8,2017,3.2,54,,-3.548,55.504,"o"],
[4179,29.9,2017,2.3,13,,-2.353,55.867,"o"],
[4184,6.9,2018,2.3,3,,-5.66,55.545,"o"],
[4189,42.0,2023,4.2,10,149.9,-4.91,55.181,"o"],
[4193,8.0,2017,2.0,4,,-3.746,51.583,"o"],
[4194,12.0,2017,2.0,6,,-3.45,51.56,"o"],
[4196,1.5,2014,1.5,1,,-3.748,51.563,"o"],
[4200,24.0,2021,3.0,8,,-4.729,55.918,"o"],
[4206,5.0,2015,2.5,2,,-1.621,53.092,"o"],
[4210,14.4,2014,1.6,9,,-0.652,52.362,"o"],
[4211,19.2,2016,3.2,6,,-3.562,55.821,"o"],
[4213,24.0,2023,3.0,8,125.0,-3.912,55.901,"o"],
[4215,13.8,2016,2.3,6,,-2.534,55.926,"o"],
[4218,8.5,2017,2.83,3,,-3.779,55.904,"o"],
[4223,12.0,2016,2.0,6,,-3.782,56.204,"o"],
[4225,51.7,2016,2.35,22,126.0,-3.532,55.809,"o"],
[4227,7.5,2017,3.0,3,,-4.26,50.808,"o"],
[4233,6.0,2016,2.0,3,,-3.503,54.603,"o"],
[4235,6.4,2016,3.2,2,,-4.781,55.736,"o"],
[4240,7.5,2014,2.5,3,,-4.09,55.742,"o"],
[4244,177.0,2018,3.0,59,126.0,-3.132,57.351,"o"],
[4245,13.8,2017,2.3,6,,-7.01,54.567,"o"],
[4246,5.0,2017,1.6,3,,-6.178,54.79,"o"],
[4247,22.5,2016,2.5,9,,-4.123,56.089,"o"],
[4248,26.0,2016,2.0,13,100.0,-0.032,52.642,"o"],
[4249,37.5,2017,2.5,15,,-6.765,54.981,"o"],
[4250,20.5,2013,1.95,10,,-1.764,55.52,"o"],
[4253,48.4,2016,1.67,29,,-3.763,55.762,"o"],
[4255,7.5,2017,2.5,3,,-7.048,54.553,"o"],
[4256,16.4,2017,2.0,8,115.0,-0.001,53.51,"o"],
[4260,68.0,2015,2.0,34,,-0.764,53.612,"o"],
[4261,66.7,2014,2.3,29,,-3.475,57.447,"o"],
[4262,50.0,2018,2.0,25,120.0,-4.174,55.312,"o"],
[4263,30.75,2017,2.05,15,111.0,-3.672,55.805,"o"],
[4264,13.8,2017,2.3,6,,-7.214,54.884,"o"],
[4266,18.0,2016,2.0,9,,-3.867,50.78,"o"],
[4269,69.0,2016,3.0,23,,-4.488,55.304,"o"],
[4272,9.0,2015,3.0,3,,-6.481,58.208,"o"],
[4281,8.3,2016,3.2,3,147.0,-3.606,55.758,"o"],
[4295,1.5,2014,1.5,1,,-0.634,51.952,"o"],
[4297,23.5,,1.8,10,,-6.801,54.995,"o"],
[4299,9.2,2017,2.3,4,,-3.263,58.595,"o"],
[4300,92.4,2023,4.2,22,125.0,-4.511,58.219,"o"],
[4307,27.2,2023,3.4,8,,-3.765,55.836,"o"],
[4315,9.0,,2.3,3,,-4.789,55.663,"uc"],
[4316,13.2,2018,2.2,6,,-2.915,55.01,"o"],
[4320,12.5,2017,2.5,5,,-7.049,54.569,"o"],
[4321,16.0,2015,2.0,8,,-2.15,53.75,"o"],
[4325,16.1,2017,2.0,7,,-7.09,54.477,"o"],
[4326,7.5,2017,2.5,3,,0.271,50.829,"o"],
[4327,15.0,2013,2.5,6,,-0.597,53.835,"o"],
[4328,6.0,2015,2.0,3,,-5.481,55.934,"o"],
[4330,10.0,2019,2.0,5,115.0,-3.455,58.449,"o"],
[4331,48.3,2016,2.3,21,,-5.31,56.153,"o"],
[4332,60.8,2017,3.2,19,145.0,-2.49,55.917,"o"],
[4335,6.9,2017,2.3,3,100.0,-2.5,51.572,"o"],
[4337,36.0,2017,3.0,12,,-3.984,55.624,"o"],
[4345,10.3,2015,2.05,5,,0.061,52.535,"o"],
[4346,2.3,2014,2.3,1,,-2.3,57.566,"o"],
[4348,7.5,2017,2.35,3,,-2.379,56.84,"o"],
[4350,10.0,2017,2.5,5,100.0,-2.899,57.464,"o"],
[4351,36.0,,3.6,10,127.0,-3.221,58.418,"uc"],
[4354,13.6,2015,3.4,4,,-2.112,53.668,"o"],
[4360,6.9,2017,2.3,3,,-2.616,57.591,"o"],
[4361,6.0,2017,2.0,3,,-6.708,54.811,"o"],
[4362,29.9,2015,2.3,13,,-4.098,55.609,"o"],
[4363,18.4,2014,2.3,8,,-3.081,56.174,"o"],
[4365,25.0,2014,2.5,10,,-2.396,56.836,"o"],
[4368,66.0,2017,3.0,22,,-3.975,55.54,"o"],
[4369,16.4,2016,2.05,8,,0.166,53.363,"o"],
[4370,2.5,2014,2.5,1,,-4.618,55.593,"o"],
[4371,48.5,2022,2.5,20,110.0,-4.086,57.321,"o"],
[4373,32.8,2014,2.05,16,,-0.889,53.666,"o"],
[4374,1.5,2014,1.5,1,,-0.005,52.521,"o"],
[4377,14.4,,2.5,7,,-3.274,52.235,"uc"],
[4381,27.6,2016,2.3,12,99.0,-3.616,57.511,"o"],
[4385,62.0,,4.8,13,180.0,-3.946,55.498,"uc"],
[4386,239.0,2017,2.5,96,,-4.802,54.988,"o"],
[4390,8.0,2017,2.0,4,,-1.326,54.546,"o"],
[4395,18.0,2014,3.0,6,,-4.841,57.68,"o"],
[4399,7.2,2014,0.8,9,,-0.862,52.162,"o"],
[4403,8.8,2018,2.0,4,,0.863,51.396,"o"],
[4404,1.5,2014,1.5,1,127.0,-3.159,56.164,"o"],
[4408,18.0,2017,2.5,9,115.0,-1.933,53.779,"o"],
[4409,20.0,2017,2.5,8,125.0,-3.522,51.587,"o"],
[4410,8.6,2015,2.85,3,,-1.402,53.574,"o"],
[4411,4.6,2017,2.3,2,,-2.372,56.815,"o"],
[4412,4.0,2018,1.33,3,,-3.276,51.775,"o"],
[4414,8.0,2015,2.0,4,,-0.122,52.468,"o"],
[4415,12.5,2017,2.5,5,,-1.321,54.647,"o"],
[4418,208.0,,6.2,35,200.0,-4.074,58.44,"uc"],
[4419,12.3,2014,3.0,5,,-2.159,53.701,"o"],
[4420,39.0,2019,3.0,13,125.0,-3.892,57.393,"o"],
[4422,10.0,2014,2.5,4,,-2.405,56.827,"o"],
[4424,12.5,2015,2.0,5,,-1.107,52.327,"o"],
[4425,18.5,2017,2.05,9,,-3.216,58.435,"o"],
[4427,30.0,2014,2.5,12,,-4.209,55.659,"o"],
[4431,90.0,2017,3.0,30,120.0,-4.203,55.292,"o"],
[4432,8.2,2019,2.05,4,,-0.166,53.859,"o"],
[4434,5.1,2019,0.85,6,,-2.833,55.822,"o"],
[4435,8.1,2013,2.03,4,,-4.788,54.866,"o"],
[4437,25.0,2017,2.5,10,,-3.515,55.249,"o"],
[4440,51.0,2019,3.4,15,,-3.804,55.513,"o"],
[4441,32.4,2018,3.4,9,,-4.047,55.344,"o"],
[4445,9.1,2012,1.3,7,,-4.516,54.872,"o"],
[4449,30.0,2020,2.0,15,,-3.108,55.1,"o"],
[4450,4.0,2014,2.0,2,,-3.769,56.215,"o"],
[4462,35.0,2017,2.5,14,137.0,-4.658,54.802,"o"],
[4465,2.5,2017,2.5,1,,-5.087,54.868,"o"],
[4480,81.0,,4.5,18,149.9,-4.248,55.369,"uc"],
[4483,1.6,2017,0.8,2,,-5.001,51.774,"o"],
[4484,2.4,2015,0.8,3,,-3.76,54.956,"o"],
[4485,2.5,2016,2.5,1,,-3.644,51.741,"o"],
[4493,1.6,2015,1.6,1,,-1.325,52.64,"o"],
[4497,1.3,2015,1.3,1,,-2.143,52.164,"o"],
[4501,15.3,2014,0.85,18,,-4.728,54.859,"o"],
[4502,25.3,2018,2.3,11,,-4.029,55.357,"o"],
[4504,54.0,2008,3.0,18,,-7.628,54.19,"o"],
[4508,22.0,2010,2.0,11,,-5.088,54.877,"o"],
[4511,6.8,2014,2.26,3,,-2.387,56.94,"o"],
[4513,14.4,2016,2.05,7,,-0.755,52.45,"o"],
[4514,1.0,2015,0.5,2,,-3.949,55.379,"o"],
[4516,4.5,2017,0.9,5,,-2.825,55.817,"o"],
[4517,36.8,2008,2.3,16,,-3.353,55.122,"o"],
[4518,19.5,2005,1.3,15,,-4.775,54.97,"o"],
[4519,18.2,2007,1.3,14,,-4.045,55.223,"o"],
[4520,30.0,2008,2.0,15,,-3.651,55.184,"o"],
[4524,10.0,2007,2.5,4,,-3.069,55.164,"o"],
[4525,43.7,2014,2.3,19,,-5.587,55.573,"o"],
[4526,48.0,2008,3.0,16,125.0,-2.49,55.917,"o"],
[4527,21.6,1996,0.6,36,,-4.183,55.297,"o"],
[4529,4.0,,2.0,2,,-4.316,55.173,"uc"],
[4532,9.0,2017,2.5,3,,-0.814,53.048,"o"],
[4544,31.0,2017,3.45,9,,-3.026,55.011,"o"],
[4552,96.0,2019,3.0,32,145.0,-3.489,53.071,"o"],
[4557,7.1,2017,2.35,3,110.0,-7.111,54.513,"o"],
[4558,21.0,2018,2.3,9,,-6.176,54.951,"o"],
[4563,22.0,2018,2.0,11,,-6.193,54.933,"o"],
[4575,6.9,2017,2.3,3,,-2.391,55.921,"o"],
[4580,15.0,2016,3.0,5,,-3.763,55.762,"o"],
[4584,62.4,,4.8,13,180.0,-4.022,58.473,"uc"],
[4586,240.0,2023,4.8,50,150.0,-4.293,55.317,"o"],
[4591,81.7,2021,4.3,19,145.0,-2.453,55.893,"o"],
[4593,22.0,2017,2.0,11,,-4.99,55.001,"o"],
[4595,228.0,2017,3.0,76,,-3.696,51.656,"o"],
[4597,227.7,2018,3.45,66,135.0,-4.526,57.127,"o"],
[4598,4.0,2014,2.0,2,,-1.158,52.35,"o"],
[4599,14.4,2018,2.05,7,,-3.313,56.655,"o"],
[4600,28.7,2016,2.0,14,,-2.321,55.897,"o"],
[4601,5.0,2017,2.5,2,,-2.364,55.935,"o"],
[4604,10.0,2015,2.5,5,,-4.821,50.496,"o"],
[4605,35.0,2022,2.5,14,110.0,-5.644,55.568,"o"],
[4615,87.6,,,20,180.0,-4.242,55.276,"uc"],
[4619,46.0,2013,2.3,20,,-5.295,56.339,"o"],
[4620,16.0,2015,1.6,10,,-2.94,55.471,"o"],
[4623,37.0,2015,2.05,18,,-2.866,57.366,"o"],
[4624,9.2,2014,2.3,4,,-4.271,50.919,"o"],
[4625,67.7,2015,2.05,33,,-4.034,58.49,"o"],
[4627,18.4,2014,2.3,8,,-2.486,56.969,"o"],
[4628,67.2,2024,4.48,15,200.0,-4.036,55.633,"o"],
[4629,1.5,2015,0.5,3,,-6.832,57.942,"o"],
[4631,48.0,,4.0,11,200.0,-2.528,55.903,"uc"],
[4633,48.0,2021,4.8,10,177.0,-3.173,55.176,"o"],
[4636,34.0,2021,2.3,15,120.0,-3.444,58.431,"o"],
[4637,4.0,2016,2.5,2,,-0.104,52.664,"o"],
[4638,27.5,2016,2.5,11,,-4.754,54.963,"o"],
[4640,110.0,2017,3.43,32,135.0,-4.582,57.219,"o"],
[4642,12.0,2017,2.5,6,,-1.497,54.575,"o"],
[4643,88.4,2019,3.4,26,,-4.036,55.633,"o"],
[4644,6.0,2017,2.0,3,,-3.615,51.643,"o"],
[4645,25.0,2016,2.3,11,,-4.779,55.226,"o"],
[4646,26.7,2019,2.05,13,112.0,-3.429,58.42,"o"],
[4647,29.7,2016,3.3,9,,-0.231,54.048,"o"],
[4648,32.8,2019,2.05,16,,-3.938,51.749,"o"],
[4649,13.8,2015,2.3,6,,0.687,52.884,"o"],
[4650,27.0,,3.0,9,,-7.45,54.587,"uc"],
[4651,10.0,2015,2.0,5,,-4.962,50.466,"o"],
[4652,27.6,2016,2.0,12,,-6.442,54.984,"o"],
[4653,13.8,2017,2.3,6,,-6.979,54.623,"o"],
[4654,15.0,2017,2.3,6,,-7.896,54.338,"o"],
[4655,10.2,2015,3.4,3,125.0,-2.167,53.7,"o"],
[4656,24.0,2017,2.0,12,,-3.621,51.645,"o"],
[4657,8.2,2016,2.0,5,,0.691,52.857,"o"],
[4658,10.3,2016,2.05,3,125.0,-1.336,53.812,"o"],
[4659,23.8,2015,3.4,7,,-2.115,53.67,"o"],
[4660,7.5,2017,2.5,3,,-0.114,53.677,"o"],
[4661,8.2,2014,2.05,4,,-4.996,51.702,"o"],
[4662,20.7,2014,2.3,9,,0.892,51.663,"o"],
[4663,3.4,2012,3.4,1,,-1.499,55.129,"o"],
[4664,69.5,2016,3.0,23,120.0,-4.36,57.19,"o"],
[4665,8.0,2014,2.0,4,,-1.634,53.084,"o"],
[4666,20.0,2014,2.0,10,,-0.245,52.059,"o"],
[4667,57.5,2013,2.3,25,,-2.486,56.969,"o"],
[4668,6.0,2008,2.0,3,,-4.806,55.644,"o"],
[4669,29.8,2005,1.75,17,,-4.329,57.805,"o"],
[4670,23.0,2009,2.3,10,,-4.238,51.978,"o"],
[4671,16.7,2006,2.0,8,,-2.639,57.665,"o"],
[4672,20.0,2006,2.0,10,,-0.643,52.361,"o"],
[4673,22.8,2005,1.75,13,,-8.093,54.418,"o"],
[4674,41.4,2010,2.3,18,,-6.432,57.469,"o"],
[4675,43.0,2010,2.15,20,,-4.632,57.533,"o"],
[4676,92.0,2005,2.3,40,,-4.103,57.334,"o"],
[4677,32.0,2005,2.0,16,,-3.629,51.683,"o"],
[4678,1.8,2010,1.75,1,,-3.097,58.841,"o"],
[4679,5.2,2007,1.3,4,,-3.688,58.602,"o"],
[4680,10.5,2006,1.75,6,,-7.605,54.634,"o"],
[4681,4.0,2006,2.0,2,,-2.894,56.484,"o"],
[4682,40.0,2008,2.5,16,125.0,-4.884,57.155,"o"],
[4683,12.3,2011,2.05,6,,-3.586,55.767,"o"],
[4684,14.5,2005,0.85,17,,-3.428,52.578,"o"],
[4685,4.5,2007,1.5,3,,-2.303,53.773,"o"],
[4686,14.4,2006,1.8,8,,0.732,52.629,"o"],
[4687,65.0,2006,2.3,28,,-3.476,57.446,"o"],
[4688,9.0,2009,1.5,6,,-7.696,54.547,"o"],
[4689,21.3,2005,0.85,25,,-3.491,53.117,"o"],
[4690,5.2,2008,1.3,4,,-1.443,54.72,"o"],
[4691,18.0,2006,3.0,6,,-4.789,55.722,"o"],
[4747,1.5,2016,1.5,1,125.0,-3.73,55.871,"o"],
[4790,1.8,2019,0.9,2,78.0,-3.201,53.29,"o"],
[4817,10.0,2020,2.3,4,115.0,-3.33,56.306,"o"],
[4892,2.4,2017,0.8,3,79.0,-2.613,57.622,"o"],
[4908,1.5,2014,1.5,1,144.0,-0.836,51.842,"o"],
[4917,1.5,2016,1.5,1,126.0,-1.218,53.075,"o"],
[4976,2.2,2014,1.0,2,64.0,0.08,51.526,"o"],
[4988,18.8,2024,2.35,8,110.0,-4.74,55.306,"o"],
[4995,5.0,2017,2.5,2,117.0,-0.534,53.717,"o"],
[5187,1.5,2021,1.5,1,100.0,-3.68,58.601,"o"],
[5195,72.6,,6.6,11,180.0,-3.328,58.347,"uc"],
[5277,7.5,2017,2.75,3,137.0,-0.656,52.354,"o"],
[5393,45.0,2023,4.2,13,149.9,-3.89,55.587,"o"],
[5455,48.0,2023,,12,,-3.959,55.572,"o"],
[5555,2.3,2016,2.3,2,126.0,-2.974,51.556,"o"],
[5598,37.6,2018,2.35,16,110.0,-3.503,53.109,"o"],
[5637,4.8,2019,0.8,6,74.0,-2.842,55.839,"o"],
[6005,79.8,2025,4.2,19,149.9,-3.742,58.528,"o"],
[6013,2.5,,2.5,1,125.0,-3.671,51.508,"o"],
[6033,1.5,2017,1.5,1,100.0,-3.499,53.018,"o"],
[6079,1.5,2018,1.5,1,116.0,-3.391,51.559,"o"],
[6106,1.5,2015,1.5,1,119.0,-3.933,55.687,"o"],
[6120,4.1,2024,4.1,1,150.0,-0.631,51.955,"o"],
[6147,33.6,2024,4.8,7,149.9,-2.73,55.354,"o"],
[6173,2.6,2016,0.85,3,70.0,-3.91,55.633,"o"],
[6214,16.0,,2.0,8,100.0,-2.281,55.898,"uc"],
[6293,2.5,2019,1.5,1,130.0,-2.689,51.517,"o"],
[6318,1.5,2017,1.5,1,,-4.068,56.045,"o"],
[6324,10.8,2020,3.6,3,135.0,-3.76,56.209,"o"],
[6327,45.6,,5.7,8,200.0,-3.628,55.813,"uc"],
[6363,46.2,,,7,200.0,-3.651,55.511,"uc"],
[6378,1.5,,1.5,1,122.0,-3.479,51.634,"uc"],
[6388,1.5,2015,0.75,2,71.0,-2.418,55.915,"o"],
[6422,2.5,2021,2.5,1,126.0,-3.425,51.559,"o"],
[6509,3.5,2021,3.5,1,150.0,-2.849,51.571,"o"],
[6590,37.8,,,9,82.0,-3.9,55.32,"uc"],
[6607,205.8,,,49,149.9,-4.36,55.352,"uc"],
[6629,308.0,,,44,200.0,-4.072,55.308,"uc"],
[6636,2.6,2003,,2,99.0,-3.688,58.602,"o"],
[6703,81.6,2023,,24,125.0,-4.051,55.372,"o"],
[6708,48.0,2024,,10,149.9,-3.816,55.604,"o"],
[6798,72.8,,5.6,13,200.0,-4.797,55.069,"uc"],
[6818,0.9,,,1,77.0,-4.603,50.663,"uc"],
[6826,78.0,,,13,200.0,-3.89,55.587,"uc"],
[6828,443.0,2024,,103,155.0,-1.208,60.339,"o"],
[7304,4.7,2024,2.35,2,119.0,-2.608,57.572,"o"],
[7312,1.9,2021,,2,77.0,-2.271,53.002,"o"],
[7340,50.4,,5.6,9,180.0,-4.737,54.994,"uc"],
[7376,3.0,,,2,150.0,-4.633,55.595,"uc"],
[7524,4.2,2023,,1,150.0,-2.674,51.538,"o"],
[7544,0.2,,,1,40.0,-5.929,54.246,"o"],
[7562,43.0,2021,,12,125.0,-4.179,55.275,"o"],
[7588,2.3,2020,,1,99.0,-5.056,50.321,"o"],
[7595,3.0,,,2,119.0,-1.841,57.566,"uc"],
[7708,21.0,2025,,5,149.9,-3.714,58.528,"o"],
[7991,8.4,,,2,150.0,-3.776,55.84,"uc"],
[8046,0.2,2021,,3,35.0,-3.338,58.309,"o"],
[8468,46.2,,,8,200.0,-3.13,57.446,"uc"],
[8884,49.9,,,10,200.0,-4.367,57.991,"uc"],
[10304,14.4,,4.8,3,150.0,-4.988,51.712,"uc"],
[11259,1.0,2017,0.5,2,77.0,-2.387,51.602,"o"],
[11706,1.0,,1.0,1,76.5,-2.558,56.648,"uc"],
[12275,36.0,,6.0,6,250.0,-4.181,55.588,"uc"],
[15144,8.4,2023,4.2,2,149.38,-3.844,55.775,"o"],
[15275,4.3,,4.3,1,135.0,-4.824,50.35,"uc"],
[15874,1.0,,1.0,1,76.0,-2.553,56.886,"uc"],
]
